import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnInit } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { ToastData } from './toast-config';
import { ToastRef } from './toast-ref';

@Component({
  selector: 'mtg-toast',
  templateUrl: './toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('openClose', [
      transition(':enter', [
        style({opacity: 0}),
        animate('0.3s ease-in', style({opacity: 1}))
      ]),
      transition(':leave', [
        style({opacity: 1}),
        animate('0.3s ease-out', style({opacity: 0}))
      ])
    ])
  ],
})
export class ToastComponent implements OnInit {
  @HostBinding('@openClose') true;

  constructor(
    readonly data: ToastData,
    readonly ref: ToastRef,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.cdr.markForCheck();
    setTimeout(() => {
      this.close();
    }, this.data.duration || 5000);
  }

  close() {
    this.ref.close();
    this.cdr.markForCheck();
  }
}
